const index = "dropdown";

export const dropdownEndpoint = Object.freeze({
  dropdown: index,
});
